import { BCMSRecord, useBCMSContext } from "@bcm-dev/bcms-vite";
import Classes, { Account } from "model";
import TASPositivePayCreateTemplatePage from "components/pages/TASPositivePayCreateTemplatePage";
import CaptureNotShownView from "components/shared/views/CaptureNotShownView";

/**
 * @name CapturePositivePayImportChecksCreateTemplate
 * @returns {React.Component}
 * @description A capture in the "Positive Pay - Import Checks" capture group.
 */
export default function CapturePositivePayImportChecksCreateTemplate(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const { branding } = context.state;
    const hasBusinessAccounts = Account.hasBusinessAccounts(branding);

    if(!hasBusinessAccounts) {
        const message = Account.businessOnlyBrandingErrorMessage;
        return <CaptureNotShownView message={ message }/>;
    }

    return <TASPositivePayCreateTemplatePage  />;
}